export default "__VITE_ASSET__C9zOlb8d__"